import { defineMessages } from "./define.js";

/**
 * Последний шаг после регистрации: позвать второго.
 *
 * Это приложение на двоих, в котором пока один. «Создайте первый список» — не
 * то первое действие, которое здесь имеет смысл; смысл имеет одно — чтобы
 * второй человек оказался внутри. Приглашение сделано подробно и хорошо, и до
 * сих пор о нём на первом экране не было сказано ни слова.
 */
export const welcome = defineMessages("welcome", {
  inviteTitle: { ru: "Позовите второго", en: "Bring the other one in" },
  inviteLede: {
    ru: "Пространство на двоих, и пока в нём один. Передайте этот код тому, с кем собираетесь его вести.",
    en: "A space for two, with one of you in it. Pass this code to whoever you are keeping it with.",
  },
  inviteWhere: {
    ru: "Код живёт неделю. Новый всегда можно выписать в настройках.",
    en: "The code lasts a week. You can always issue another in the settings.",
  },
  inviteMinting: { ru: "Выписываем код…", en: "Issuing the code…" },
  inviteCodeAria: { ru: "Код приглашения", en: "Invitation code" },
  inviteCopy: { ru: "Скопировать ссылку", en: "Copy the link" },
  inviteCopied: { ru: "Ссылка скопирована", en: "Link copied" },
  inviteDone: { ru: "Готово", en: "Done" },
  /** Когда код не выписался: тупика нет, настройки на месте. */
  inviteLater: { ru: "Позже, в настройках", en: "Later, in the settings" },
});
